export const trace =
    import.meta.env.DEV || localStorage.getItem('enableTrace') === 'true'
        ? // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
          (...args: any) => console.log('[src/index]', ...args)
        : () => {};
